import { Block, IconButton } from '@aloft/toolkit-sui';

import { forwardRef } from 'react';

import { selectActiveTour } from '../../redux/features/selectors/uiSelectors.ts';
import { setActiveTour } from '../../redux/features/uiSlice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { UIState } from '../../redux/types.ts';

export const GuidedTourTrigger = forwardRef<HTMLButtonElement, { tourID: UIState['activeTour'] }>(
  ({ tourID }, ref) => {
    const dispatch = useAppDispatch();
    const activeTour = useAppSelector(selectActiveTour);

    return (
      <Block position="absolute" bottom=".25rem" right=".25rem">
        <IconButton
          ref={ref}
          icon="school"
          size="md"
          iconSize="lg"
          variant="primary"
          ariaLabel="Guided Tour"
          onClick={() =>
            dispatch(
              setActiveTour({
                activeTour: activeTour === tourID ? null : tourID,
              }),
            )
          }
          isRound
        />
      </Block>
    );
  },
);
